import React from "react"
import { Button } from "react-bootstrap"

import { getFormattedMessage } from "../../components/shared_components_registration"

export default function PageErrorPanel({ errorMessage, attemptReload }) {
  return (
    <div className={"center_middle"} style={{ height: "300px" }}>
      <div align={"center"} className={"text-danger"}>
        <span className={"fa fa-exclamation-triangle text-danger"} style={{ fontSize: "50px" }} />
        <br />
        <h5 className={"text-danger"}>
          {getFormattedMessage("datatransfer.error.message", "Error! Something went wrong")}
        </h5>
        {errorMessage ? (
          <div style={{ marginBottom: "15px" }}>
            <span className={"text-danger"}>{errorMessage}</span>
          </div>
        ) : (
          ""
        )}
        <Button variant={"danger"} onClick={attemptReload} style={{ marginTop: "10px" }}>
          {getFormattedMessage("datatransfer.try.again", "Try Again")}
        </Button>
      </div>
    </div>
  )
}
